<!-- eslint-disable vue/multi-word-component-names -->
<script>
  import AppTitleHeader from '@/components/app/TitleHeader.vue';
  import AppBox from '@/components/app/box.vue';
  import AppConversation from '@/components/app/conversation.vue';
  export default {
    components: {
      AppTitleHeader,
      AppBox,
      AppConversation,
    },

    props: {
      consciousnessLevelTitle: {
        type: String,
        default: '-',
      },
      respirationTitle: {
        type: String,
        default: '-',
      },
      airwayTitle: {
        type: String,
        default: '-',
      },
      bloodCirculationTitle: {
        type: String,
        default: '-',
      },
      patientDetails: {
        type: Array,
        default: () => [],
      },
      patientTechnicianReportNote: {
        type: String,
        default: '-',
      },
      patientAccompanyingSymptoms: {
        type: Array,
        default: () => [],
      },
    },
  };
</script>
<template>
  <v-row no-gutters class="pa-4">
    <v-col cols="12" class="mb-5">
      <app-title-header title="ارزیابی اولیه" />
      <app-box outlined class="flex-gap-2 justify-between mt-4">
        <div class="flex-grow first-col">
          <app-conversation
            :between="true"
            question="سطح هوشیاری"
            :answer="consciousnessLevelTitle"
            class="mb-2"
          />
          <app-conversation :between="true" question="تنفس" :answer="respirationTitle" />
        </div>
        <div class="flex-grow second-col">
          <app-conversation
            :between="true"
            question="راه هوایی"
            :answer="airwayTitle"
            class="mb-2"
          />
          <app-conversation :between="true" question="گردش خون" :answer="bloodCirculationTitle" />
        </div>
      </app-box>
    </v-col>
    <v-col
      v-for="({ typeOfEmergencyTitle, diagnosis, diagnosisDetail }, index) in patientDetails"
      :key="index"
      cols="12"
      class="mb-5"
    >
      <app-title-header title="تشخیص" />
      <app-box outlined class="flex-gap-2 justify-between mt-4">
        <div class="flex-grow first-col">
          <app-conversation
            :between="true"
            question="نوع ماموریت"
            :answer="typeOfEmergencyTitle"
            class="mb-2"
          />
          <app-conversation :between="true" question="تشخیص" :answer="diagnosis" />
        </div>
        <div class="flex-grow second-col">
          <app-conversation :between="true" question="جزئیات" :answer="diagnosisDetail" />
        </div>
      </app-box>
    </v-col>
    <v-col cols="6" class="mb-5 pl-4">
      <app-title-header title="علائم همراه" class="mb-4" />
      <app-box outlined max-height="324px">
        <v-expansion-panels flat class="flex flex-col gap-2">
          <v-expansion-panel
            v-for="({ title }, i) in patientAccompanyingSymptoms"
            :key="i"
            class="patient-accompanying-symptom rounded"
          >
            <v-expansion-panel-header>{{ title }}</v-expansion-panel-header>
            <!-- <v-expansion-panel-content>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </v-expansion-panel-content> -->
          </v-expansion-panel>
        </v-expansion-panels>
      </app-box>
    </v-col>
    <v-col cols="6">
      <app-title-header title="توضیحات" class="mb-4" />
      <app-box outlined max-height="324px">
        <p>{{ patientTechnicianReportNote }}</p>
      </app-box>
    </v-col>
  </v-row>
</template>
<style lang="scss">
  .patient-accompanying-symptom {
    background-color: var(--background-color) !important;
    border-radius: 6px;
  }
</style>
<style lang="scss" scoped>
  .first-col {
    padding-left: 0.5rem;
    border-left: 1px solid #21212133;
    width: 100%;
  }
  .second-col {
    width: 100%;
  }
</style>
